// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { ActionType } from '../tbs/action-type.js';


export class LeavePlayerSlotAction implements flatbuffers.IUnpackableObject<LeavePlayerSlotActionT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):LeavePlayerSlotAction {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsLeavePlayerSlotAction(bb:flatbuffers.ByteBuffer, obj?:LeavePlayerSlotAction):LeavePlayerSlotAction {
  return (obj || new LeavePlayerSlotAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsLeavePlayerSlotAction(bb:flatbuffers.ByteBuffer, obj?:LeavePlayerSlotAction):LeavePlayerSlotAction {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new LeavePlayerSlotAction()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

type():ActionType {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : ActionType.LobbyLeavePlayerSlot;
}

playerId():number {
  const offset = this.bb!.__offset(this.bb_pos, 6);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : 0;
}

static startLeavePlayerSlotAction(builder:flatbuffers.Builder) {
  builder.startObject(2);
}

static addType(builder:flatbuffers.Builder, type:ActionType) {
  builder.addFieldInt16(0, type, ActionType.LobbyLeavePlayerSlot);
}

static addPlayerId(builder:flatbuffers.Builder, playerId:number) {
  builder.addFieldInt16(1, playerId, 0);
}

static endLeavePlayerSlotAction(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createLeavePlayerSlotAction(builder:flatbuffers.Builder, type:ActionType, playerId:number):flatbuffers.Offset {
  LeavePlayerSlotAction.startLeavePlayerSlotAction(builder);
  LeavePlayerSlotAction.addType(builder, type);
  LeavePlayerSlotAction.addPlayerId(builder, playerId);
  return LeavePlayerSlotAction.endLeavePlayerSlotAction(builder);
}

unpack(): LeavePlayerSlotActionT {
  return new LeavePlayerSlotActionT(
    this.type(),
    this.playerId()
  );
}


unpackTo(_o: LeavePlayerSlotActionT): void {
  _o.type = this.type();
  _o.playerId = this.playerId();
}
}

export class LeavePlayerSlotActionT implements flatbuffers.IGeneratedObject {
constructor(
  public type: ActionType = ActionType.LobbyLeavePlayerSlot,
  public playerId: number = 0
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return LeavePlayerSlotAction.createLeavePlayerSlotAction(builder,
    this.type,
    this.playerId
  );
}
}
